import { computed, ref } from "vue";
import {
  ThemeInput,
  WidgetConfigurationTheme,
} from "@superagent-dev/superagent-chat-lib";

const theme = ref<WidgetConfigurationTheme>();

export function useWidgetTheme() {
  if (!theme.value) {
    theme.value = {
      headerBackgroundColor: "#504BE5", // Superagent purple
      headerTextColor: "#e0e7ff", // indigo-100
      launcherIconColor: "#FFFFFF", // white
      launcherBackgroundColor: "#504BE5", // Superagent purple
      primaryColor: "#504BE5", // Superagent purple,
      primaryTextColor: "#FFFFFF",
      secondaryColor: "#e5e7eb", // gray-200,
      secondaryTextColor: "#374151",
      mainBackgroundColor: "#FFFFFF", // white
    };
  }

  const setTheme = (newTheme: ThemeInput) => {
    const compiledTheme: WidgetConfigurationTheme = {
      ...theme.value!,
      ...newTheme,
    };

    theme.value = compiledTheme;
  };

  return {
    setTheme,

    theme: computed(() => theme.value),
  };
}
